import React from "react";
import _ from "lodash";
import { dater, dt_dater } from "../../helpers";
import { DateTime } from "luxon";

// ============================ TRF ==============================
export function getTransferBasicData({ reservation, t }) {
  if (!reservation) return [];

  var output = [
    [t("origin"), reservation.origin_name],
    [t("location"), reservation.destination_name],
    [t("reference"), reservation.reference],
    [t("inboundDate"), dater(reservation.inbound_start)],
  ];

  if (reservation.outbound_start) {
    output.push([t("outboundDate"), dater(reservation.outbound_start)]);
  }

  const extraOutput = [
    [
      t("created"),
      DateTime.fromISO(reservation.created).toLocaleString(
        DateTime.DATETIME_SHORT
      ),
    ],
    [
      t("status"),
      reservation.status === "CO"
        ? t("confirmed")
        : reservation.status === "CA"
        ? t("cancelled")
        : t("pending"),
    ],
  ];
  return [...output, ...extraOutput];
}

export function getTransferExtraData({ reservation, t }) {
  if (!reservation) return [];

  const output = [
    [
      t("freeCancellationAvailable"),
      reservation.non_refundable ? t("no") : t("yes"),
    ],
  ];

  const extraOutput = [
    [
      t("freeCancellationDeadline"),
      dt_dater(reservation.max_cancellation_date),
    ],
  ];
  return reservation.non_refundable ? output : [...output, ...extraOutput];
}

export function getTransferPax({ reservation, t }) {
  if (!reservation) return [];

  return _.get(reservation, "guests", []).map((guest) => [
    [t("type"), guest.guest_type_display],
    [t("title"), guest.guest_title_display],
    [t("firstName"), guest.first_name],
    [t("lastName"), guest.last_name],
    [t("email"), guest.email],
    ["leadGuest", guest.group_leader ? <strong>{t("yes")}</strong> : ""],
  ]);
}
